export const RTL_VOUCHER_SESSION_KEY = 'rtl_voucher_flow';

function hasCampaignQueryParam(query) {
  const campaign = query?.campaign;
  if (campaign == null) {
    return false;
  }
  if (Array.isArray(campaign)) {
    return campaign.length > 0 && String(campaign[0]) !== '';
  }
  return String(campaign) !== '';
}

/**
 * fetch3 options for GET orders/purchase_form.
 * URL ?campaign= always wins; route meta.campaign is used only when the URL has no campaign.
 */
export function buildPurchaseFormFetchOptions(route) {
  const opts = {
    url: 'orders/purchase_form',
    method: 'get',
    addQueryString: true,
  };
  if (!hasCampaignQueryParam(route?.query) && route?.meta?.campaign) {
    opts.queryString = `campaign=${encodeURIComponent(String(route.meta.campaign))}`;
  }
  return opts;
}
